import { DocumentFile } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { DocumentList, ProductDetailsContext, ProductSection } from '@components';
import { t } from '@translations';
import { getCommerceMediaByType } from '@utils/media.utils';
import { useContext } from 'react';

export const ProductDocuments = () => {
  const { product = {}, sections, onSectionEnter } = useContext(ProductDetailsContext);
  if (!sections?.documents) {
    return null;
  }
  const { commerceMediaCollection = [] } = product;
  const documentMedia = getCommerceMediaByType(commerceMediaCollection, 'Media');
  const documents: DocumentFile[] = documentMedia.map((x) => ({
    displayName: x?.title,
    name: x?.name,
    url: x?.contentLink?.url,
    altText: x.altText,
    fileSize: x.fileSize,
  }));
  return (
    <ProductSection
      sectionId='documents'
      title={t(TextCodes.Product.Details.Documents)}
      onSectionEnter={onSectionEnter}
    >
      <DocumentList documents={documents} showAlert />
    </ProductSection>
  );
};
